<script setup>
import { BButton, BModal, BFormCheckboxGroup, BFormCheckbox } from 'bootstrap-vue-next'
import { ref, defineModel, defineProps } from 'vue'

const checked=defineModel()
const props = defineProps({
    options: Array
})
const modal = ref(false)
</script>

<template>
    <div class="d-flex justify-content-start mt-3">
        <BButton @click="modal = !modal" variant="light">
            <i class="fa fa-filter"></i>
            <span class="ml-2">Filter</span>
        </BButton>

    </div>
    <BModal v-model="modal" no-footer title="Filter">
        <div class="d-flex align-items-center">
            <BFormCheckboxGroup
                class="d-block"
                v-model="checked"
                :aria-describedby="ariaDescribedby"
            >

            <BFormCheckbox class="d-block py-2" v-for="p in props.options" :key="p.key" :value="p.key">{{ p.label }}</BFormCheckbox>
            
            </BFormCheckboxGroup>
        </div>
    </BModal>
</template>

<style scoped>
.modal-dialog{
    width: 300px;
}
</style>